<template>
	<div class="ims-sales">

		<border-view title="IMS销量地图分布">
			<div class="view-search" style="padding-top: 24px;">
				<FromComm :FromArr="FromArr" />
				<CommonBtngroup class="btngroup" :qhide="false" @select="handSearch('')" @reset="handReset('')" />
			</div>
			<!-- 图表 -->
			<div class="view-row">
				<ims-map ref="imsmap" @select="getHospitalSalesTOP" />
				<hosp-table :datas="hospInfo" :name="provName" />
			</div>
		</border-view>

		<border-view title="IMS销售历史销量图">
			<div class="view-search"
				style="padding-top: 24px;height:150px;align-items: flex-end;flex-direction: column;">
				<FromComm :FromArr="FromArr2" @selectChange="selectChange2"
					@remoteMethod="(e)=>getCustomerList2(e.qurey)" />
				<CommonBtngroup class="btngroup" style="margin-bottom: 24px;" :qhide="false" @select="handSearch('2')"
					@reset="handReset('2')" />
			</div>
			<div class="view-switch-list">
				<div class="view-switch">
					<div class="switch-item-red" v-for="(item,index) in switchYeItems" :key="index"
						:class="[yearIndex===index?'current-red':'']" @click="switchChange(index,'year')">
						{{item}}
					</div>
				</div>
			</div>
			<!-- 图表 -->
			<company-year v-if="dataInfo2" :info="dataInfo2" :type="yearIndex" />
		</border-view>

		<border-view title="L3医院销量趋势图">
			<div class="view-search" style="padding-top: 24px;min-height:210px;">
				<FromComm :FromArr="FromArr3" @selectChange="selectChange3" @remoteMethod="remoteMethod" />
				<CommonBtngroup class="btngroup" style="min-width:180px;" :qhide="false" @select="handSearch('3')"
					@reset="handReset('3')" />
			</div>
			<div class="view-switch-list">
				<div class="view-switch" style="margin-right:48px;">
					<div class="switch-item-red" v-for="(item,index) in switchYeItems" :key="index"
						:class="[l3Index===index?'current-red':'']" @click="switchChange(index,'l3')">
						{{item}}
					</div>
				</div>
				<div class="view-switch">
					<div class="switch-item-blue" v-for="(item,index) in switchSJItems" :key="index"
						:class="[sjIndex===index?'current-blue':'']" @click="switchChange(index,'sj')">
						{{item}}
					</div>
				</div>
			</div>
			<!-- 图表 -->
			<company-trend v-if="dataInfo3&&sjIndex===0" :info="dataInfo3" :type="l3Index" />
			<!-- 图表 -->
			<company-money v-if="dataInfo3&&sjIndex===1" :info="dataInfo3" :type="l3Index" />
		</border-view>

		<border-view title="IMS省份排名">
			<div class="view-search" style="padding-top: 24px;min-height: 130px;">
				<FromComm :FromArr="FromArr4" @selectChange="selectChange4" />
				<CommonBtngroup class="btngroup" style="min-width:180px;" :qhide="false" @select="handSearch('4')"
					@reset="handReset('4')" />
			</div>
			<div class="view-table">
				<el-table :data="dataInfo4" style="width: 100%" height="500">
					<el-table-column v-for="(item,index) in tableHead" :key="index" :label="item.label"
						:width="item.width" :fixed="item.fixed">
						<template slot-scope="scope">
							{{scope.row[item.key]}}
						</template>
					</el-table-column>
				</el-table>
			</div>
		</border-view>
	</div>
</template>

<script>
	import {
		GetHelperLevel1,
		GetHospitalSalesTOP,
		GetHelperLevel3,
		SMSReportZyloxHospitalBySalesAmount,
		GetSMSReportZyloxHospitalTendency,
		GetHelperAreaMan,
		GetHelperRegionMan,
		GetHelperSalesMan,
		GetProvinceSalesAmount,
		GetHospitalList,
		GetCustomerList,
		GetProvinceIMSRanking
	} from '@/api/newsapi'
	import imsMap from './charts/ims-map.vue';
	import hospTable from './charts/hosp-table.vue';
	import companyYear from './charts/company-year.vue';
	import companyTrend from './charts/company-trend.vue';
	import companyMoney from './charts/company-money.vue';
	import FromComm from '../../../views/home/components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../../components/commongroup.vue'
	import borderView from './border-view.vue';
	import {
		FromArr,
		FromArr2,
		FromArr3,
		FromArr4
	} from '../FormData/imsSales';
	export default {
		components: {
			imsMap,
			hospTable,
			FromComm,
			CommonBtngroup,
			companyYear,
			companyTrend,
			companyMoney,
			borderView
		},
		data() {
			return {
				FromArr: [],
				FromArr2: [],
				FromArr3: [],
				FromArr4: [],
				switchYeItems: ['月度', '季度', '年度'],
				yearIndex: 1,
				switchSJItems: ['数量', '金额'],
				sjIndex: 0, //数量金额
				l3Index: 1,
				query: {},
				dataInfo: null,
				hospInfo: null,
				provName: '',
				query2: {},
				dataInfo2: null,
				query3: {},
				dataInfo3: null,
				query4: {},
				dataInfo4: null,
				tableHead: [{
					"label": '省份',
					"key": 'ProvinceName',
					"width": "auto",
				}, {
					"label": '数量',
					"key": 'Quantity',
					"width": "auto"
				}, {
					"label": 'GTS',
					"key": 'StandardSum',
					"width": "auto"
				}],
			}
		},
		created() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.FromArr2 = JSON.parse(JSON.stringify(FromArr2))
			this.FromArr3 = JSON.parse(JSON.stringify(FromArr3))
			this.FromArr4 = JSON.parse(JSON.stringify(FromArr4))
			this.getHelperLevel1();
			this.getHospitalSalesTOP({
				query: this.query,
				name: ''
			})
			this.getHelperLevel3();
			this.smsReportZyloxHospitalBySalesAmount();
			this.getSMSReportZyloxHospitalTendency();
			this.getProvinceSalesAmount();
			this.getInnerQuotaDetail();
		},
		methods: {
			//获取l1数据
			async getHelperLevel1() {
				let {
					code,
					data
				} = await GetHelperLevel1({})
				if (code == 0) {
					this.FromArr[0].options = [{
						key: '不限',
						value: '',
					}]
					this.FromArr2[0].options = [{
						key: '不限',
						value: '',
					}]
					this.FromArr3[0].options = [{
						key: '不限',
						value: '',
					}]
					this.FromArr4[1].options = [{
						key: '不限',
						value: '',
					}]
					data.map((item, index) => {
						let obj = {
							key: item.value,
							value: item.key
						}
						this.FromArr[0].options.push(obj);
						this.FromArr2[0].options.push(obj);
						this.FromArr3[0].options.push(obj);
						this.FromArr4[1].options.push(obj);
					})
				}
			}, //获取l3数据
			async getHelperLevel3(l1 = '') {
				let params = {};
				if (l1) {
					params.LEVEL1 = l1;
				}
				let {
					code,
					data
				} = await GetHelperLevel3(params);

				if (code == 0) {
					if (!l1) {
						this.FromArr[2].options = [];
						this.FromArr2[1].options = [];
					}
					this.FromArr3[1].options = [];
					this.FromArr4[2].options = [];
					data.map((item, index) => {
						let obj = {
							key: item.value,
							value: item.key
						}
						if (!l1) {
							this.FromArr[2].options.push(obj);
							this.FromArr2[1].options.push(obj);
						}
						this.FromArr3[1].options.push(obj);
						this.FromArr4[2].options.push(obj);
					})
				}
			},
			//获取医院top20
			async getHospitalSalesTOP(e = null) {
				let params = {};
				if (e) {
					params = Object.assign({}, e.query);
					this.provName = e.name;
					params.ProvinceName = e.name;
				}
				let {
					code,
					data
				} = await GetHospitalSalesTOP(params);

				if (code == 0) {
					this.hospInfo = data;
				}
			}, // 公司商业历年销售 
			async smsReportZyloxHospitalBySalesAmount() {
				let params = {};
				params.ByQuarter = this.yearIndex;
				params = Object.assign({}, params, this.query2);

				let {
					code,
					data
				} = await SMSReportZyloxHospitalBySalesAmount(params);

				if (code == 0) {
					this.dataInfo2 = data.salesAmountReport;
				}
			}, // L3商业销量趋势图
			async getSMSReportZyloxHospitalTendency(e = {}) {
				let params = {};
				params.ByQuarter = this.l3Index;
				params = Object.assign({}, params, e, this.query3);

				let {
					code,
					data
				} = await GetSMSReportZyloxHospitalTendency(params);

				if (code == 0) {
					this.dataInfo3 = data.tendencyReport;
				}
			},
			//获取大区经理
			async getHelperAreaMan(l1 = '') {
				let params = {};
				if (l1) {
					params.LEVEL1 = l1;
				}
				let {
					code,
					data
				} = await GetHelperAreaMan(params);

				if (code == 0) {
					this.FromArr2[2].options = [];
					this.FromArr3[2].options = [];
					data.map((item, index) => {
						let obj = {
							key: item.key,
							value: item.value
						}
						this.FromArr2[2].options.push(obj);
						this.FromArr3[2].options.push(obj);
					})
				}
			},
			//三级销售（地区）
			async getHelperRegionMan(str, l1) {
				let {
					code,
					data
				} = await GetHelperRegionMan({
					ParentUserName: str,
					LEVEL1: l1
				});

				if (code == 0) {
					this.FromArr2[3].options = [];
					this.FromArr3[3].options = [];
					data.map((item, index) => {
						let obj = {
							key: item.key,
							value: item.value
						}
						this.FromArr2[3].options.push(obj);
						this.FromArr3[3].options.push(obj);
					})
				}
			},
			//销售代表
			async getHelperSalesMan(str, l1) {
				let {
					code,
					data
				} = await GetHelperSalesMan({
					ParentUserName: str,
					LEVEL1: l1
				});

				if (code == 0) {
					this.FromArr3[4].options = [];
					data.map((item, index) => {
						let obj = {
							key: item.key,
							value: item.value
						}
						this.FromArr3[4].options.push(obj);
					})
				}
			},
			//省份
			async getProvinceSalesAmount() {
				let {
					code,
					data
				} = await GetProvinceSalesAmount({});

				if (code == 0) {
					this.FromArr2[4].options = [{
						key: '不限',
						value: ''
					}];
					this.FromArr3[5].options = [{
						key: '不限',
						value: ''
					}];
					data.data.map((item, index) => {
						let obj = {
							key: item.Name,
							value: item.Name
						}
						this.FromArr2[4].options.push(obj);
						this.FromArr3[5].options.push(obj);
					})
				}
			},
			//医院列表
			async getHospitalList(hpName = '') {
				let {
					code,
					data
				} = await GetHospitalList({
					HPName: hpName,
					pageIndex: 1,
					pageSize: 9999,
					IsTerminalHPOnly: 1
				})
				if (code == 0) {
					this.FromArr3[6].options = []
					data.data.map((item, index) => {
						let obj = {
							label: item.HPName,
							value: item.HPID
						}
						this.FromArr3[6].options.push(obj)
					})
				}
			},
			//经销商列表
			async getCustomerList2(CusName = '') {
				let {
					code,
					data
				} = await GetCustomerList({
					CusName: CusName,
					pageIndex: 1,
					pageSize: 9999
				})
				if (code == 0) {
					this.FromArr2[5].options = []
					data.data.map((item, index) => {
						let obj = {
							label: item.CusName,
							value: item.CusCode
						}
						this.FromArr2[5].options.push(obj)
					})
				}
			},
			//经销商列表
			async getCustomerList(CusName = '') {
				let {
					code,
					data
				} = await GetCustomerList({
					CusName: CusName,
					pageIndex: 1,
					pageSize: 9999
				})
				if (code == 0) {
					this.FromArr3[7].options = []
					data.data.map((item, index) => {
						let obj = {
							label: item.CusName,
							value: item.CusCode
						}
						this.FromArr3[7].options.push(obj)
					})
				}
			},
			//省份排名
			async getInnerQuotaDetail() {
				let {
					code,
					data
				} = await GetProvinceIMSRanking(this.query4)
				if (code == 0) {
					this.dataInfo4 = data;
				}
			},
			remoteMethod(param) {
				if (param.parsign === "hospitalMethod") {
					this.getHospitalList(param.qurey);
				}

				if (param.parsign === "customMethod") {
					this.getCustomerList(param.qurey);
				}
			},
			handReset(e = '') {
				if (e == '2') {
					this.FromArr2.map((item, index) => {
						item.modelvalue = '';
					})
					this.query2 = {};
					this.smsReportZyloxHospitalBySalesAmount();
				} else if (e == '3') {
					this.FromArr3.map((item, index) => {
						item.modelvalue = '';
					})
					this.query3 = {};
					this.getSMSReportZyloxHospitalTendency();
				} else if (e == '4') {
					this.FromArr4.map((item, index) => {
						item.modelvalue = '';
					})
					this.query4 = {};
					this.getInnerQuotaDetail();
				} else {
					this.FromArr.map((item, index) => {
						item.modelvalue = '';
						item.StartTime = '';
						item.EndTime = '';
					})
					this.query = {};
					this.$refs.imsmap.init(this.query);
					this.getHospitalSalesTOP('');
				}
			},
			handSearch(e = '') {
				if (e == '2') {
					this.query2.LEVEL1 = this.FromArr2[0].modelvalue;
					this.query2.LEVEL3 = this.FromArr2[1].modelvalue ? this.FromArr2[1].modelvalue.join(',') : '';

					this.query2.AreaMan = this.FromArr2[2].modelvalue ? this.FromArr2[2].modelvalue.join(',') : '';
					this.query2.RegionMan = this.FromArr2[3].modelvalue ? this.FromArr2[3].modelvalue.join(',') : '';
					this.query2.ProvinceName = this.FromArr2[4].modelvalue;
					this.query2.CusCode = this.FromArr2[5].modelvalue ? this.FromArr2[5].modelvalue.join(',') : '';
					this.smsReportZyloxHospitalBySalesAmount();
				} else if (e == '3') {
					this.query3.LEVEL1 = this.FromArr3[0].modelvalue;
					this.query3.LEVEL3 = this.FromArr3[1].modelvalue ? this.FromArr3[1].modelvalue.join(',') : '';

					this.query3.AreaMan = this.FromArr3[2].modelvalue ? this.FromArr3[2].modelvalue.join(',') : '';
					this.query3.RegionMan = this.FromArr3[3].modelvalue ? this.FromArr3[3].modelvalue.join(',') : '';
					this.query3.SalesMan = this.FromArr3[4].modelvalue ? this.FromArr3[4].modelvalue.join(',') : '';
					this.query3.ProvinceName = this.FromArr3[5].modelvalue;
					this.query3.HPID = this.FromArr3[6].modelvalue ? this.FromArr3[6].modelvalue.join(',') : '';
					this.query3.TerminalHPID = this.FromArr3[6].modelvalue ? this.FromArr3[6].modelvalue.join(',') : '';
					this.query3.CusCode = this.FromArr3[7].modelvalue ? this.FromArr3[7].modelvalue.join(',') : '';
					this.getSMSReportZyloxHospitalTendency();
				} else if (e == '4') {
					this.query4.Year = this.FromArr4[0].modelvalue;
					this.query4.InvClass = this.FromArr4[1].modelvalue;
					this.query4.LEVEL3 = this.FromArr4[2].modelvalue ? this.FromArr4[2].modelvalue.join(',') : '';
					this.query4.StartMonth = this.FromArr4[3].modelvalue;
					this.query4.EndMonth = this.FromArr4[4].modelvalue;
					this.getInnerQuotaDetail();
				} else {
					this.query.LEVEL1 = this.FromArr[0].modelvalue;
					this.query.Year = this.FromArr[1].modelvalue;
					this.query.LEVEL3 = this.FromArr[2].modelvalue ? this.FromArr[2].modelvalue.join(',') : '';
					this.query.startDate = this.FromArr[3].modelvalue || this.FromArr[3].modelvalue.length ? this.FromArr[
						3].modelvalue[0] : '';
					this.query.endDate = this.FromArr[3].modelvalue || this.FromArr[3].modelvalue.length ? this.FromArr[3]
						.modelvalue[1] : '';
					this.$refs.imsmap.init(this.query);
					this.getHospitalSalesTOP({
						query: this.query,
						name: ''
					})
				}
			},

			switchChange(e, k) {
				this[k + 'Index'] = e;
				if (k === 'year') {
					this.smsReportZyloxHospitalBySalesAmount();
				}
				if (k === 'l3' || k === 'sj') {
					this.getSMSReportZyloxHospitalTendency();
				}
			},
			//FromArr2 下拉框触发事件
			selectChange2(e) {
				console.log(e);
				switch (e) {
					case 0:
						this.getHelperLevel3(this.FromArr2[0].modelvalue === '不限' ? '' : this.FromArr2[0].modelvalue);
						this.getHelperAreaMan(this.FromArr2[0].modelvalue === '不限' ? '' : this.FromArr2[0].modelvalue)
						this.getHelperRegionMan(this.FromArr2[2].modelvalue.join(','), this.FromArr2[0].modelvalue ===
							'不限' ? '' : this.FromArr2[0].modelvalue);
						this.getHelperSalesMan(this.FromArr2[2].modelvalue.join(','), this.FromArr2[0].modelvalue ===
							'不限' ? '' : this.FromArr2[0].modelvalue);
						break;
					case 2:
						this.getHelperRegionMan(this.FromArr2[2].modelvalue.join(','));
						break;
				}
			},
			//FromArr3 下拉框触发事件
			selectChange3(e) {
				console.log(e);
				switch (e) {
					case 0:
						this.getHelperLevel3(this.FromArr3[0].modelvalue === '不限' ? '' : this.FromArr3[0].modelvalue);
						this.getHelperAreaMan(this.FromArr3[0].modelvalue === '不限' ? '' : this.FromArr3[0].modelvalue)
						this.getHelperRegionMan(this.FromArr3[2].modelvalue.join(','), this.FromArr3[0].modelvalue ===
							'不限' ? '' : this.FromArr3[0].modelvalue);
						this.getHelperSalesMan(this.FromArr3[2].modelvalue.join(','), this.FromArr3[0].modelvalue ===
							'不限' ? '' : this.FromArr3[0].modelvalue);
						break;
					case 1:
						break;
					case 2:
						this.getHelperRegionMan(this.FromArr3[2].modelvalue.join(','));
						break;
					case 3:
						this.getHelperSalesMan(this.FromArr3[3].modelvalue.join(','));
						break;
					case 4:
						break;
				}
			},
			//FromArr4 下拉框触发事件
			selectChange4(e) {
				if (e == 1) {
					this.FromArr4[2].options = [];
					this.FromArr4[2].modelvalue = '';
					this.getHelperLevel3(this.FromArr4[1].modelvalue === '不限' ? '' : this.FromArr4[1].modelvalue);
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.ims-sales {
		padding-bottom: 200px;

		.view-row {
			display: flex;
		}

		.view-search {
			height: 88px;
			margin: 16px 0px 16px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			border-bottom: 1px solid #E5E5E5;

			.search-title {
				font-size: 16px;
				font-family: HarmonyOS Sans SC-Medium, HarmonyOS Sans SC;
				font-weight: 500;
				color: #1D2129;
				position: absolute;
				top: 16px;
				left: 16px;
			}

			.switch-list {

				// display: flex;
				// justify-content: flex-end;
				// padding: 0rpx 30rpx;


			}

			.view-switch {
				border-radius: 2px;
				overflow: hidden;
				display: flex;
				cursor: pointer;
				position: absolute;
				top: 16px;
				right: 16px;

				.switch-item {
					width: 54px;
					height: 28px;
					line-height: 28px;
					text-align: center;
					background: #FFFFFF;
					box-sizing: border-box;
					border: 1px solid #E5E6EB;
					font-size: 14px;
					font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
					font-weight: 400;
					color: #4E5969;
				}

				.switch-item:first-child {
					border-radius: 2px 0px 0px 2px;
					border-right: 0px;
				}

				.switch-item:last-child {
					border-radius: 0px 2px 2px 0px;
					border-left: 0px;
				}

				.current {
					border: 1px solid #BF0030;
					background: #BF0030;
					color: #FFFFFF;
				}

				.current2 {
					border: 1px solid #00266D;
					background: #00266D;
					color: #FFFFFF;
				}
			}


			.btngroup {
				float: none;
				//margin-left: 24px;
				margin-top: 0px;
			}
		}

		.view-table {
			margin: 24px;
			padding-bottom: 24px;

			/deep/.el-table {

				.el-table__body-wrapper::-webkit-scrollbar {
					width: 6px;
					height: 6px;
					background-color: white;
					cursor: pointer;
					border-radius: 12px;
				}

				// /*定义滑块 内阴影+圆角*/
				.el-table__body-wrapper::-webkit-scrollbar-thumb {
					box-shadow: inset 0 0 0px white;
					-webkit-box-shadow: inset 0 0 0px white;
					background-color: #D9D9D9;
					border-radius: 12px;
					cursor: pointer;
				}
			}
		}

		.merge {
			min-height: 88px;
			padding-bottom: 22px;
			position: relative;
			margin-bottom: 0px;
			align-items: flex-end;
		}

		.content-view {
			background: #FFFFFF;
			margin-top: 16rpx;
			position: relative;
		}

		.view-switch-list {
			display: flex;
			align-items: center;
			justify-content: center;

			.view-switch {
				overflow: hidden;
				display: flex;
				cursor: pointer;

				.switch-item-red {
					width: 80px;
					height: 32px;
					line-height: 32px;
					text-align: center;
					box-sizing: border-box;
					font-size: 14px;
					font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
					font-weight: 400;
					color: #E71D43;
					background: url('../../../../assets/report/btn-red.png') no-repeat;
					background-size: 100% 100%;
					margin: 0px 8px;
				}

				.switch-item-blue {
					width: 80px;
					height: 32px;
					line-height: 32px;
					text-align: center;
					box-sizing: border-box;
					font-size: 14px;
					font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
					font-weight: 400;
					color: #00266D;
					background: url('../../../../assets/report/btn-blue.png') no-repeat;
					background-size: 100% 100%;
					margin: 0px 8px;
				}

				.current-red {
					background: url('../../../../assets/report/btn-red-checked.png') no-repeat;
					background-size: 100% 100%;
					color: #FFFFFF;
				}

				.current-blue {
					background: url('../../../../assets/report/btn-blue-checked.png') no-repeat;
					background-size: 100% 100%;
					color: #FFFFFF;
				}
			}
		}
	}
</style>